import MexicoMap from "./MexicoMap";
import CurveText from '../../assets/images/Doodles/curveText.svg'
import SharkySpraypaint from "../../assets/images/Sharky/Sharky_Spraypaint.png"
import ActivityItem from "./ActivityItem";
import beVisioneers from "../../assets/images/Logos/Premios/beVisioneers.webp"
import hp from "../../assets/images/Logos/Premios/hp.jpg"
import uhf from "../../assets/images/Logos/Premios/uhf.jpeg"

import { useTranslation } from 'react-i18next'
import Article from "./Article";
import { useState } from "react";

import gsap from 'gsap'
import { useGSAP } from '@gsap/react';
import ScrollTrigger from "gsap/ScrollTrigger";
import ActivityData from "./ActivityData";
gsap.registerPlugin(useGSAP);


function Impact({className}) {

    const actData = ActivityData();

    useGSAP(() => {
        console.log(actData)
        ScrollTrigger.refresh()
        let mm = gsap.matchMedia();
        
        mm.add("(min-width: 768px)", () =>{
            gsap.to('.find-us', {
            x: () => {
            const element = document.querySelector('.find-us');
            return -element.scrollWidth + window.innerWidth - 200;
            },
            ease: 'none',
            scrollTrigger: {
            trigger: '.find-us',
            start: 'bottom 80%',
            end: 'bottom 50%',
            pin: ".impact-data",
            pinSpacing: true,
            scrub: 1,
            markers:false,
            invalidateOnRefresh: false,
            onLeave: () => {
                const trigg = ScrollTrigger.getById('act-trigger');
                if (trigg) {
                    trigg.refresh();
                }
            }
            }
        });

        // ScrollTrigger para la sección 'activity'
        gsap.to('.activity', {
                        x: () => {
            const element = document.querySelector('.activity');
            return -element.scrollWidth + window.innerWidth - 200;
            },
            ease: 'none',
            scrollTrigger: {
            trigger: '.activity',
            start: 'bottom 80%',
            end: 'bottom 50%',
            pin: ".miaww",
            pinSpacing: true,
            scrub: 1,
            markers:false,
            invalidateOnRefresh: true,
            id: "act-trigger"
            
            }
        });
        })

        mm.add("(max-width: 767px)", () =>{
            gsap.to('.find-us', {
            x: () => {
            const element = document.querySelector('.find-us');
            return -element.scrollWidth + window.innerWidth - 200;
            },
            ease: 'none',
            scrollTrigger: {
            trigger: '.find-us',
            start: 'bottom 80%',
            end: 'bottom 50%',
            pin: ".miaww",
            pinSpacing: true,
            scrub: 1,
            markers:false,
            id: 'find-us-trigger',
            invalidateOnRefresh: false,
            
            onLeave: () => {
                const trigg = ScrollTrigger.getById('act-trigger');
                if (trigg) {
                    console.log("sali")
                    trigg.refresh();
                }
            }
            }
        });

        // ScrollTrigger para la sección 'activity'
        gsap.to('.activity', {
                        x: () => {
            const element = document.querySelector('.activity');
            return -element.scrollWidth + window.innerWidth - 200;
            },
            ease: 'none',
            scrollTrigger: {
            trigger: '.activity',
            start: () => {
                const findusheight = document.querySelector('.find-us');
                return "bottom+="+findusheight.scrollHeight + " 80%"
            },
            end: () => {
                const findusheight = document.querySelector('.find-us');
                return "bottom+="+findusheight.scrollHeight + " 50%"
            },
            pin: ".miaww",
            pinSpacing: true,
            scrub: 1,
            markers:false,
            invalidateOnRefresh: true,
            refreshPriority: 0,
            id: "act-trigger"
            
            }
        });
        })
        


    }, []);

    const { t, i18n } = useTranslation(['common', 'navigation']);

    const [articles] = useState([
        {
            title: "Forbes",
            desc: "«BLUEKALI: una empresa social que utiliza tecnología para limpiar océanos y ríos, abordando los desafíos en el reciclaje de material vegetal y mejorando los puestos de trabajo de los pepenadores.»",
            link: "https://forbes.com.mx/forbes-life/conoce-a-las-ganadoras-del-premio-unlock-her-future-2024-edicion-latam/"
        },
        {
            title: "Wired",
            desc: "«El Premio Unlock Her Future, presentado por The Bicester Collection en colaboración con el Tecnológico de Monterrey y con el apoyo de Ashoka México, Centroamérica y el Caribe, ofrece hasta $100,000 dólares, así como un programa de tutoría con expertos y formación adicional para ayudarlas a desarrollar su visión empresarial y hacer crecer sus nuevas empresas.»",
            link: "https://es.wired.com/articulos/premio-unlock-her-future-ellas-son-las-finalistas-de-america-latina"
        },
        {
            title: "Wired",
            desc: "Entrevista a Annie Rosas, cofundadora BLUEKALI, un proyecto dedicado a limpiar y proteger océanos y ríos por medio del uso de tecnologías como la biomimética y la Inteligencia Artificial.",
            link: "https://es.wired.com/articulos/annie-rosas-imagino-un-futuro-donde-las-tecnologias-revolucionen-la-limpieza-y-proteccion-de-nuestros-cuerpos-de-agua"
        },
        {
            title: "El Financiero",
            desc: "Las ocho finalistas fueron elegidas mediante un proceso riguroso que consideró impacto social, ambiental o cultural, viabilidad y escalabilidad—y luego participaron en una aceleradora intensiva con el Tecnológico de Monterrey en CDMX, antes de presentar en São Paulo ante un panel de jueces internacionales",
            link: "https://www.elfinanciero.com.mx/mundo-empresa/2024/06/14/las-finalistas-del-premio-unlock-her-future-2024-latam-edition-son-un-impulso-al-emprendimiento-femenino-en-america-latina/"
        },
        {
            title: "El Heraldo",
            desc: "Bluekali fueron reconocidas en Madrid por desarrollar tecnología con Inteligencia Artificial para limpiar ríos, lagos y océanos:",
            link: "https://heraldodemexico.com.mx/tendencias/2024/7/4/unlock-her-future-mujeres-innovadoras-fueron-premiadas-por-the-bicester-collection-617819.html"
        },
        {
            title: "Impakter",
            desc: "How Startup Bluekali Cleans Latin America’s Rivers and Oceans",
            link: "https://impakter.com/how-startup-bluekali-cleans-latin-americas-rivers-and-oceans/"
        },
        {
            title: "El mundo de Regina",
            desc: "Annie Rosas, la mexicana que fue una de las ganadoras del premio Unlock Her Future 2024, Edición LATAM, celebrado en Madrid.",
            link: "https://www.youtube.com/watch?v=2CKTsso3dnc"
        },
        {
            title: "PR Newswire",
            desc: "The Bicester Collection anuncia a las ganadoras del Unlock Her Future Prize 2024 LATAM Edition",
            link: "https://www.prnewswire.com/news-releases/the-bicester-collection-anuncia-a-las-ganadoras-del-unlock-her-future-prize-2024-latam-edition-302175657.html"
        },
        {
            title: "Business People",
            desc: "The Bicester Collection anuncia las ganadoras de Unlock Her Future Prize 2024 LATAM Edition",
            link: "https://business-people.es/empleo/leadership/the-bicester-collection-anuncia-las-ganadoras-de-unlock-her-future-prize-2024-latam-edition/"
        },
        {
            title: "Marie Claire",
            desc: "Annie Rosas, de México, con su proyecto BLUEKALI, demostró el poder de la tecnología para limpiar océanos y ríos. Su enfoque en la recolección de material vegetal reciclado también mejora las condiciones de trabajo de los recolectores.",
            link: "https://marieclaire.com.mx/unlock-her-future-latam-edition-mujeres-ganadoras/"
        },
        {
            title: "Conecta",
            desc: "Colecta por el futuro: EXATEC Puebla es reconocida internacionalmente",
            link: "https://conecta.tec.mx/es/noticias/puebla/emprendedores/colecta-por-el-futuro-exatec-puebla-es-reconocida-internacionalmente"
        },
        {
            title: "Alternativa Educación",
            desc: "Estudiantes Tec usan tecnología para limpiar ríos y mares",
            link: "https://alternativaeducacion.com/tag/bluekali/"
        },
        {
            title: "Mexpreneurs",
            desc: "Bluekali is a Mexican startup leveraging nature-inspired technology to clean rivers and lakes.",
            link: "https://www.mexpreneurs.com/startups/bluekali"
        },
        {
            title: "Imagen TV",
            desc: "Conoce a la mexicana que puso a México en lo más alto con Bluekali y el premio Unlock Her Future",
            link: "https://www.tiktok.com/@paolarojas/video/7438694005845560631"
        }
    ]);

    return(
        <div id='section-impact' className={`section-impact miaww flex flex-col md:flex-col justify-between md:justify-start min-h-screen overflow-hidden items-start ${className} bg-gradient-to-b from-bluekali-han-purple to-bluekali-navy-blue`}>
            <div className="w-full md:h-full md:flex md:flex-col md:justify-start">
                    <h1 className="text-3xl md:text-5xl font-bold ml-6 md:ml-16 mt-24">{t('impact.title')}</h1>
                <div className="flex flex-col md:flex-row">
                    <div className="w-full md:pl-6">
                    <MexicoMap/>
                    </div>
                

                    {/* Stats */}
                    <div className="flex pl-6 flex-col mdflex-wrap md:flex-col space-y-4 w-full justify-start md:justify-end items-stretch md:items-start md:px-6">
                        <div className="flex flex-col items-start md:items-start md:justify-start">
                            <h1 className="text-6xl md:text-6xl font-black transform -translate-x-1">4</h1>
                            <h3 className="text-xs text-bluekali-white/90 md:text-base font-black text-left md:text-left w-48">{t('impact.communities')}</h3>
                        </div>
                        <div className="flex flex-col items-start md:items-start md:justify-start">
                            <div className="flex">
                                <h1 className="text-6xl md:text-6xl font-black ">+500<span className="text-sm">kg</span></h1>
                            </div>
                            <h3 className="text-xs text-bluekali-white/90 md:text-base font-black text-center md:text-left">{t('impact.trash_recovered')}</h3>
                        </div>
                        <div className="flex flex-col items-start md:items-start md:justify-start">
                            <h1 className="text-6xl md:text-6xl font-black transform -translate-x-1">3</h1>
                            <h3 className="text-xs text-bluekali-white/90 md:text-base font-black text-center md:text-left">{t('impact.workshops')}</h3>
                        </div>
                    </div>
                </div>
                
            </div>
            

            {/* Awards */}
            <div className="impact-data flex flex-col w-full md:pt-16 md:ml-16 md:min-h-screen md:flex md:flex-col md:justify-between mt-16 md:mt-0">
                <div>
                    <h1 className="text-2xl md:text-4xl font-black ml-6 text-bluekali-white/80 md:mt-8">{t('impact.awards')}</h1>
                    {/* awards */}
                    <div className="awards flex pl-6 space-x-10 mt-4 md:mt-10 mb-8 overflow-hidden">
                        <img src={beVisioneers} alt="Be Visioneers" className="h-20"/>
                        <img src={hp} alt="Be Visioneers" className="h-20"/>
                        <img src={uhf} alt="Be Visioneers" className="h-20"/>
                    </div>
                </div>

                <div>
                    <h1 className="text-2xl md:text-4xl font-black ml-6 text-bluekali-white/80">{t('impact.find_us')}</h1>
                    {/* find us */}
                    <div className="find-us flex pl-6 space-x-10 mt-4 md:mt-10 mb-8 overflow-visible">
                        {articles.map((a, i) => (
                            <Article key={i} title={a.title} desc={a.desc} link={a.link}/>
                        ))}
                    </div>
                </div>

                <div
                
                onLoad={() => {

                            console.log(i18n.language);
                            }}>
                    <h1 className="text-2xl md:text-4xl font-black ml-6 text-bluekali-white/80 mb-4">{t("impact.activity")}</h1>
                    {/* activity */}
                    <div className="flex pl-6 space-x-10 activity-div overflow-visible activity">
                        {
                            actData.map((element, index) => (
                                <ActivityItem
                                    key={index} // clave única para React
                                    title={element[i18n.language].title}
                                    location={element[i18n.language].location}
                                    date={element[i18n.language].date}
                                    recolected={element.recolected}
                                    description={element[i18n.language].description}
                                    image={element.image}
                                    url={element.link}
                                />
                            ))
                        }
                    </div>
                    
                </div>

                
                <div className="relative w-full h-10 mt-40">
                    <img alt="" className="absolute bottom-0 right-0 md:h-32" src={CurveText}/>
                    <img alt="" className="absolute bottom-0 right-1/4 w-1/4 md:w-1/6" src={SharkySpraypaint}/>
                </div>
            </div>
            
        </div>
    );   
}

export default Impact;